export default __webpack_public_path__ + "images/808996a761b69ffd66839e3ddbefe1d3.svg";